var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.Is,{ref:"form",tag:"component",attrs:{"config":_vm.config,"title":_vm.title,"icon":_vm.icon},on:{"change":_vm.handleChange,"input":_vm.handleInputChange,"click":_vm.handleClick},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }